// extracted by mini-css-extract-plugin
module.exports = {"option-column":"OptionColumns_option-column__hVRyM"};